/**
 * Supported interface languages.
 *
 * `code` is the i18next key and the value stored in user preferences.
 * `dir` drives document direction, MUI theme direction and the emotion RTL cache.
 * `label` is written in the language itself — users scanning a list recognise
 * their own language faster than its English name.
 */
export const LANGUAGES = [
  { code: 'en', label: 'English', english: 'English', dir: 'ltr' },
  { code: 'ur', label: 'اردو', english: 'Urdu', dir: 'rtl' },
  { code: 'ar', label: 'العربية', english: 'Arabic', dir: 'rtl' },
  { code: 'es', label: 'Español', english: 'Spanish', dir: 'ltr' },
  { code: 'de', label: 'Deutsch', english: 'German', dir: 'ltr' },
  { code: 'fr', label: 'Français', english: 'French', dir: 'ltr' },
  { code: 'hi', label: 'हिन्दी', english: 'Hindi', dir: 'ltr' },
];

export const LANGUAGE_CODES = LANGUAGES.map((l) => l.code);
export const DEFAULT_LANGUAGE = 'en';

export const languageOf = (code) =>
  LANGUAGES.find((l) => l.code === code) || LANGUAGES[0];

export const dirOf = (code) => languageOf(code).dir;

export const isRtl = (code) => dirOf(code) === 'rtl';

/**
 * Preferences used to store the English *name* ("English", "Urdu"). Map both
 * ways so existing rows keep working and nothing is lost on save.
 */
export const codeFromName = (name) => {
  if (!name) return DEFAULT_LANGUAGE;
  if (LANGUAGE_CODES.includes(name)) return name; // already a code
  const hit = LANGUAGES.find((l) => l.english.toLowerCase() === String(name).toLowerCase());
  return hit ? hit.code : DEFAULT_LANGUAGE;
};

export const nameFromCode = (code) => languageOf(code).english;
